// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import hljs from 'highlight.js'

import I18n from 'i18n-js'
window.I18n = I18n;

Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.Stimulus = Application.start()
const context = require.context("../controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

document.addEventListener('turbolinks:load', () => {
  hljs.highlightAll();
  setTimezoneCookie();
})

require("fslightbox");

require("../custom/jq_plugins");
require("../custom/loading");
require("../custom/bamboo_datatable_init");
require('../custom/utilities');
require("../custom/modal");
require("../custom/nested_fields");
require("../custom/image_upload_preview");
require("../custom/document_upload_preview");
require('../custom/notifications');
require("../custom/confirmation_dialog");
require("../custom/char_counter");
require("../custom/translateable_tabs");
require("../custom/action_logs");
require("../custom/tinymce");
require("../custom/datetimepicker");
require("../custom/sorting");
require("../custom/remote_links_fixer");
require("../custom/server_notice");
require("../custom/filtering_action_triggers");
require('../custom/assessment_form_steps');
require("../custom/report_sections");
require("../custom/report_images_upload");
require("../custom/assessment_logs");
require("../custom/report_tables");
require("../custom/infinite_content");
require("../custom/report_issue");
require("../custom/cookies");
require("../custom/timezone_cookie");
require("../custom/group_versions");
require("../custom/multiple_select");
require("../custom/assessor_form");
require("../custom/post_form");
require("../custom/report_table_form");
require("../custom/report_table_form");
require("../custom/version_reports");
require("../custom/application_question_form");
require("../custom/fullcalendar");
require("../custom/assessor_resources_form");
require("../custom/scroll_to_stuff");
require("../custom/training_item_question_form");
require("../custom/document_field");
require("../custom/assessor_residence_filters");
require("../custom/setting_assessor_documents_form");
require("../custom/client_account_form");
require("../custom/request_from_param");
require("../custom/client_external_link_form");
require("../custom/report_refute");
require("../custom/expenses_notice");
require("../custom/payout_xlsx_export_form");
require("../custom/request_payout_form");
require("../custom/scrollable_tabs");

